export default __webpack_public_path__ + "static/media/c_bekyne_mniska-min.903bf376.jpg";